<template>
  <div class="home-page">
    <!-- 顶部导航栏 -->
    <header class="topbar">
      <div class="brand">
        <img src="/img/iqiyi.png" alt="logo" class="brand-logo" />
      </div>
      <div class="search-bar">
        <input 
          v-model="searchKeyword" 
          type="text" 
          class="search-input" 
        />
        <van-icon name="search" class="search-icon" />
      </div>
    </header>

    <!-- 标签页 -->
    <nav class="tab-row">
      <button 
        class="tab-item" 
        :class="{ active: activeTab === 'recommend' }"
        type="button" 
        @click="switchTab('recommend')"
      >{{ $t('home.recommend') || '推薦' }}</button>
      <button 
        class="tab-item" 
        :class="{ active: activeTab === 'tv_series' }"
        type="button" 
      >{{ $t('home.tv_series') || '電視劇' }}</button>
      <button 
        class="tab-item" 
        :class="{ active: activeTab === 'movie' }"
        type="button" 
      >{{ $t('home.movie') || '電影' }}</button>
      <button 
        class="tab-item" 
        :class="{ active: activeTab === 'anime' }"
        type="button" 
      >{{ $t('home.anime') || '動漫' }}</button>
    </nav>

    <!-- 英雄横幅 -->
    <section class="hero" v-if="activeTab === 'recommend'">
      <swiper class="hero-swiper" :options="bannerSwiperOption">
        <swiper-slide v-for="(v, key) in banners" :key="key">
          <van-image class="hero-image" :src="`${v.url}`" width="100%" height="100%">
            <!-- <template v-slot:loading>
              <van-loading type="circular" />
            </template> -->
          </van-image>
        </swiper-slide>
      </swiper>
    </section>

    <!-- 热门推荐 -->
    <section class="recommend-section" v-if="activeTab === 'recommend'">
      <div class="section-head">
        <span class="section-title">{{ $t('home.hot_recommend') || '熱門推薦' }} ></span>
      </div>
      <div class="recommend-strip">
        <article
          class="recommend-card"
          v-for="(item, index) in currentTabData"
          :key="item.id || index"
        >
          <div class="top-badge" v-if="index < 4">TOP {{ index + 1 }}</div>
          <div class="card-cover">
            <img :src="item.img_url" :alt="item.xuanfei_name" />
          </div>
          <div class="card-body">
            <div class="card-top">{{ item.xuanfei_name || getDefaultName(index) }}</div>
            <div class="card-link">{{ $t('home.evil_game') || '邪惡遊戲' }} ></div>
          </div>
        </article>
        <!-- 如果没有数据，显示默认卡片 -->
        <article
          class="recommend-card"
          v-for="(item, index) in (4 - currentTabData.length > 0 ? Array(4 - currentTabData.length).fill({}) : [])"
          :key="'default-' + index"
        >
          <div class="top-badge">TOP {{ currentTabData.length + index + 1 }}</div>
          <div class="card-cover">
            <img :src="getDefaultImage(index)" alt="default" />
          </div>
          <div class="card-body">
            <div class="card-top">TOP {{ currentTabData.length + index + 1 }}</div>
            <div class="card-name">{{ getDefaultName(currentTabData.length + index) }}</div>
            <div class="card-link">{{ getDefaultName(currentTabData.length + index) }} ></div>
          </div>
        </article>
      </div>
    </section>

    <!-- 页面底部占位 -->
    <div class="page-spacer"></div>

    <!-- 底部导航栏 -->
    <nav class="bottom-nav">
      <div class="nav-item active" @click="toLogin('/Home')">
        <div class="nav-icon">
          <img src="/img/neww/home.png" :alt="$t('home.home')" />
        </div>
        <span class="nav-label">{{ $t('home.home') || '首頁' }}</span>
      </div>
      <div class="nav-item" @click="toLogin('/Video')">
        <div class="nav-icon">
          <img src="/img/neww/video.png" :alt="$t('home.video_zone')" />
        </div>
        <span class="nav-label">{{ $t('home.video_zone') || '影視專區' }}</span>
      </div>
      <div class="nav-item" @click="hasToken ? toLogin('/Mine') : toLogin('/Login')">
        <div class="nav-icon">
          <img src="/img/neww/user.png" :alt="$t('home.personal_center')" />
        </div>
        <span class="nav-label">{{ $t('home.personal_center') || '個人中心' }}</span>
      </div>
    </nav>
  </div>
</template>

<script>
export default {
  data() {
    return {
      notice: this.$t("index.loading"),
      hasToken: false,
      basicData: [],
      datalist: [],
      banners: [],
      searchKeyword: '',
      activeTab: 'recommend',
      tabData: {
        recommend: [],
        tv_series: [],
        movie: [],
        anime: []
      },
      bannerSwiperOption: {
        effect: 'coverflow',
        grabCursor: true,
        centeredSlides: true,
        slidesPerView: 'auto',
        speed: 800,
        autoplay: true,
        loop: true,
        coverflowEffect: {
          rotate: 0,
          stretch: 0,
          depth: 120,
          modifier: 1,
          slideShadows: false
        }
      },
      defaultNames: [],
      defaultImages: [
        '/img/neww/room_bg.gif'
      ]
    };
  },
  computed: {
    currentTabData() {
      return this.tabData[this.activeTab] || this.datalist;
    }
  },
  methods: {
    getBasicConfig() {
      this.$http({
        method: "get",
        url: "sys_config",
      }).then((res) => {
        this.basicData = res.data;
        this.getNotice(this.basicData);
        this.getBanner(this.basicData);
      });
    },
    getBanner(data) {
      this.banners = data.banners || [];
    },
    toLogin(str) {
      this.$router.push({ path: str });
    },
    switchTab(tab) {
      this.activeTab = tab;
      if (this.tabData[tab].length === 0) {
        this.loadTabData(tab);
      }
    },
    loadTabData(tab) {
      const tabIdMap = {
        recommend: 1,
        tv_series: 2,
        movie: 3,
        anime: 4
      };
      this.$http({
        method: "get",
        url: "xuanfeilist",
        data: { id: tabIdMap[tab] || 1, page: 1 },
      }).then((res) => {
        const lanng = localStorage.getItem("lang");
        this.tabData[tab] = res.data || [];
        this.tabData[tab].forEach((item) => {
          const parts = item.flag.split('|');
          lanng == 'zh' ? item.flag = parts[0] : lanng == 'en' ? item.flag = parts[1] : lanng == 'ja' ? item.flag = parts[2] : item.flag = parts[3];
          item.flagArray = item.flag.split('锛?');
        });
      });
    },
    getNotice(data) {
      this.notice = data.notice;
    },
    toDetail(id) {
      this.$router.push({ path: "/detail", query: { id: id } });
    },
    checkToken() {
      const token = localStorage.getItem("token");
      this.hasToken = !!token;
    },
    getxuanfeilist() {
      this.$http({
        method: "get",
        url: "xuanfeilist",
        data: { id: 1, page: 1 },
      }).then((res) => {
        const lanng = localStorage.getItem("lang");
        this.datalist = res.data || [];
        this.tabData.recommend = this.datalist;
        this.datalist.forEach((item) => {
          const parts = item.flag.split('|');
          lanng == 'zh' ? item.flag = parts[0] : lanng == 'en' ? item.flag = parts[1] : lanng == 'ja' ? item.flag = parts[2] : item.flag = parts[3];
          item.flagArray = item.flag.split('锛?');
        });
      });
    },
    getDefaultName(index) {
      return this.defaultNames[index % this.defaultNames.length];
    },
    getDefaultImage(index) {
      return this.defaultImages[index % this.defaultImages.length];
    }
  },
  created() {
    this.checkToken();
    this.getBasicConfig();
    this.getxuanfeilist();
  },
};
</script>

<style lang="less" scoped>
.home-page {
  min-height: 100vh;
  background: #151515;
  color: #f5f5f5;
  padding-bottom: 60px;
}

/* 顶部导航栏 */
.topbar {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 16px;
  background: #151515;
}

.brand {
  flex: 0 0 auto;
  display: flex;
  align-items: center;
}

.brand-logo {
  width: 140px;
  height: 56px;
  object-fit: contain;
}

.search-bar {
  flex: 0 0 auto;
  width: 30vw;
  max-width: 600px;
  min-width: 400px;
  height: 64px;
  border-radius: 6px;
  background: #2f2f2f;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 12px;
  position: relative;
}

.search-input {
  flex: 1;
  background: transparent;
  border: none;
  outline: none;
  color: #fff;
  font-size: 28px;

  &::placeholder {
    color: #666;
  }
}

.search-icon {
  color: #888;
  font-size: 36px;
  position: absolute;
  top: 15px;
  right:20px
}

/* 标签页 */
.tab-row {
  display: flex;
  justify-content: space-around;
  padding: 0 16px;
  margin-bottom: 8px;
}

.tab-item {
  border: 0;
  background: transparent;
  color: #999;
  font-size: 30px;
  padding: 10px 0;
  position: relative;
}

.tab-item.active {
  color: #00d200;
  font-weight: 700;
}

.tab-item.active::after {
  content: "";
  position: absolute;
  left: 50%;
  bottom: 0;
  transform: translateX(-50%);
  width: 24px;
  height: 3px;
  border-radius: 999px;
  background: #00d200;
}

/* 英雄横幅 */
.hero {
  margin: 0 16px;
  border-radius: 8px;
  overflow: hidden;
  background: #121212;
  height: 500px;
}

.hero-swiper,
.hero-image {
  width: 100%;
  height: 100%;
}

.hero-default {
  width: 100%;
  height: 100%;
  background: linear-gradient(135deg, #1a1a2e 0%, #16213e 50%, #0f3460 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  overflow: hidden;
}

.hero-default::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: radial-gradient(circle at 80% 20%, rgba(255,255,255,0.1) 0%, transparent 50%);
}

.hero-content {
  text-align: center;
  z-index: 1;
  padding: 20px;
}

.hero-badge {
  display: inline-block;
  padding: 4px 12px;
  background: rgba(0, 210, 0, 0.2);
  border: 1px solid #00d200;
  border-radius: 4px;
  color: #00d200;
  font-size: 12px;
  margin-bottom: 16px;
}

.hero-title {
  font-size: 36px;
  font-weight: 700;
  color: #fff;
  margin: 0 0 8px;
  letter-spacing: 4px;
}

.hero-subtitle {
  font-size: 18px;
  color: #00d200;
  margin: 0 0 12px;
  letter-spacing: 6px;
}

.hero-date {
  font-size: 14px;
  color: #888;
  margin: 0;
}

/* 热门推荐 */
.recommend-section {
  margin-top: 20px;
  padding: 0 16px;
}

.section-head {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 14px;
}

.section-title {
  font-size: 32px;
  font-weight: 500;
  color: #fff;
}

.section-more {
  color: #888;
  font-size: 14px;
}

.recommend-strip {
  display: flex;
  gap: 12px;
  overflow-x: auto;
  padding-bottom: 8px;
  scrollbar-width: none;
}

.recommend-strip::-webkit-scrollbar {
  display: none;
}

.recommend-card {
  flex: 0 0 200px;
  position: relative;
  border-radius: 8px;
  overflow: hidden;
  background: #1a1a1a;
}

.top-badge {
  position: absolute;
  z-index: 2;
  right: 0;
  top: 0;
  padding: 4px 8px;
  background: #00d200;
  color: #fff;
  font-size: 24px;
  border-radius: 0 0 8px 0;
}

.card-cover {
  width: 100%;
  height: 250px;
  overflow: hidden;
}

.card-cover img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.card-body {
  padding: 10px 8px 12px;
}
.card-top {
  font-size: 28px;
  font-weight: 500;
  color: #fff;
  margin-bottom: 6px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.card-name {
  font-size: 28px;
  font-weight: 500;
  color: #fff;
  margin-bottom: 6px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.card-link {
  font-size: 24px;
  color: #fff;
}

/* 页面底部占位 */
.page-spacer {
  height: 60px;
}

/* 底部导航栏 */
.bottom-nav {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  height: 56px;
  background: #1a1a1a;
  display: flex;
  justify-content: space-around;
  align-items: center;
  border-top: 1px solid #2a2a2a;
  padding-bottom: env(safe-area-inset-bottom);
  z-index: 100;
}

.nav-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  padding: 6px 0;
  cursor: pointer;
  min-width: 60px;
}

.nav-icon {
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.nav-icon img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  filter: brightness(0.6);
}

.nav-item.active .nav-icon img {
  filter: brightness(1) saturate(1.2);
}

.nav-label {
  font-size: 11px;
  color: #666;
}

.nav-item.active .nav-label {
  color: #00d200;
}
</style>
